import Col from "components/ui-elements/Col";
import React from "react";
import Button from "./Button";
const ButtonCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <Button {...rest} />
    </Col>
  );
};

ButtonCol.defaultProps = {
  colsize: 2,
  model: "md",
  margin: "mb-1"
}

export default ButtonCol;